import game from '../game/Game'
import { NEW_GAME, SELECT_ROBOT, DESELECT_ROBOT, MOVE_ROBOT, LOAD_STATE } from '../actions/game'

const defaultState = {
  currentColor: "",
  moveCount: 0,
  solution: []
}
export default function status(state = defaultState, action) {
  switch (action.type) {
    case NEW_GAME:
      return Object.assign({}, defaultState)
    case SELECT_ROBOT:
      return Object.assign({}, state, {currentColor: action.activeColor});
    case DESELECT_ROBOT:
      return Object.assign({}, state, {currentColor: ""});
    case MOVE_ROBOT:
      if(action.targetReached){
        return Object.assign({}, defaultState)
      }
      return Object.assign({}, state, {
        moveCount: action.solution.length / 2,
        solution: action.solution
      });
    case LOAD_STATE:
      return Object.assign({}, defaultState)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/status.js